import { atom } from 'jotai';

import { AppPreview } from './types';

export const appPreviewState = atom<AppPreview>({
  isOpen: false,
});
